import { lazy } from "react";
export const ArticlesAsync = lazy(()=>import("./ArticlesPage"))